import React from 'react';
import PubSub from 'pubsub-js';

import { addClass, removeClass, hasClass } from '../dom-helper';

import selectionStore from '../packs/item_selection_store';

const TOPIC = 'item.selector';
const ALLTOPIC = 'item.select_all';

let COUNTER = 0;
let cacheListenerRegistered = false;

const resetItemSelection = () => {
  COUNTER = 0;
  document.querySelectorAll('.item-selector input[type="checkbox"]').forEach((checkbox) => {
    checkbox.checked = false;
  });
  document.querySelectorAll('.item-selector--counter').forEach((counter) => {
    counter.innerHTML = 0;
  });
};

const registerTurbolinksListeners = () => {
  if (cacheListenerRegistered) return;
  cacheListenerRegistered = true;

  document.addEventListener('turbolinks:before-cache', resetItemSelection);
  document.addEventListener('turbolinks:load', () => {
    COUNTER = selectionStore.count();
    document.querySelectorAll('.item-selector--counter').forEach((counter) => {
      counter.innerHTML = COUNTER;
    });
  });
};

registerTurbolinksListeners();

class ItemSelector extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selected: selectionStore.has(props.uuid)
    }
  }

  componentDidMount(){
    this.TOKEN = PubSub.subscribe(ALLTOPIC, (msg, data) => {

      this.setState({ selected: data.selected }, function() {
        this.publishChange(data.selected);
      });

    });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.TOKEN);
  }

  publishChange(checked) {
    if (checked) {
      selectionStore.add({ uuid: this.props.uuid, archived: this.props.archived });
    } else {
      selectionStore.remove(this.props.uuid);
    }

    COUNTER = selectionStore.count();
    
    PubSub.publish(TOPIC, {
      uuid: this.props.uuid,
      archived: this.props.archived,
      selected: checked
    });

    document.querySelectorAll('.item-selector--counter').forEach((counter) => {
      counter.innerHTML = COUNTER;
    });
  }

  handleChange(event) {
    let checked = !this.state.selected;

    this.publishChange(checked);

    this.setState({ selected: checked });
  }

  render() {
    console.log('render',this.props.uuid,'selected:',this.state.selected);
    return (
      <div className='item-selector pretty-checkbox'>
        <input id={ this.props.uuid } type='checkbox' onChange={ this.handleChange.bind(this) } checked={ this.state.selected } />
        <label htmlFor={ this.props.uuid } className='checkbox-mask'></label>
      </div>
    )
  }
}

export default ItemSelector;
